import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, cls } from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import {shouldMetadataInfoShowed} from '../../utils/Utils';
import './styles/success.scss';

const BodyContent = ({ data }) => {
    const {ticketPriceTax= {}, ticketBonus = {}, creditCardImage, account} = data || {};
    const metadataPriceTax = {}, metadataBonus = {};

    if (shouldMetadataInfoShowed()){
        metadataPriceTax['data-metadata-key'] = ticketPriceTax.key;
        metadataBonus['data-metadata-key'] = ticketBonus.key;
    }

    const isPromoGate =  data.payment_method_key === 'promogate';

    //La duracion ya se encuentra incluida en el total, por lo que esta ya no es necesaria.
    const duration = '';
    return (
        <Row className="aaf-modal-bottom-success">
            <Column lg={6} className="aaf-modal-image-large-success">
                <img src={data.img_large} alt="img_large" />
            </Column>
            <Column lg={6}>
                <Row className={cls("aaf-modal-success-info", data.type === 'subscription' ? 'suscription': 'other')}>
                    <Column lg={12}>
                        {data.providerImage &&
                        <Column lg={6} className="aaf-modal-images-center">
                            <img src={data.providerImage} alt="logo" />
                            <img
                                src={Assets.get(`ticket_subscription_icon_confirm`)}
                                alt="Check_logo"
                                className="check_logo"
                            />
                        </Column>}
                    </Column>
                    {data.title && (
                        <Column lg={4}>
                            <span className="aaf-modal-title">{data.title}</span>
                        </Column>
                    )}
                    {!data.providerImage && <Column lg={2} className="aaf-modal-success-check">
                        <img
                            src={Assets.get(`ticket_subscription_icon_confirm`)}
                            alt="Check_logo"
                        />
                    </Column>}
                    {/*!isPromoGate && data.type === 'subscription' && data.total && <Column lg={12}>
                        <span className="aaf-modal-title-total">
                            {Translator.get('subscription_totalCost_description_label', 'Total:')}
                        </span>
                        <span {...metadataPriceTax} className="aaf-modal-total-payment">{` ${ticketPriceTax.label}`}</span>
                        <span className="aaf-modal-total-duration">{duration}</span>
                    </Column>*/}
                    {!isPromoGate && ticketBonus.label && (
                        <Column lg={12}>
                            <span {...metadataBonus} className="aaf-modal-color-info">
                                {ticketBonus.label}
                            </span>
                        </Column>
                    )}
                    {data.content && (
                        <Column lg={6}>
                            <span>{data.content}</span>
                        </Column>
                    )}
                </Row>
                <Row className="aaf-modal-success-pay">
                    <Column lg={6}>
                        {!isPromoGate && data.total && <Column lg={12}>
                            <span className="aaf-modal-total">{Translator.get('', 'Total:')}</span>
                            <span {...metadataPriceTax} className="aaf-modal-total-label">{` ${ticketPriceTax.label}`}</span>
                            {data.type === 'subscription' && <span>{duration}</span>}
                        </Column>}
                        <Column className="aaf-modal-payment-accpunt-payment-container">
                            <span className="aaf-modal-payment">{Translator.get('ticket_subscription_paymentMethod_label', 'Medio de pago:')}</span><br/>
                            <span className="aaf-modal-payment-label">{` ${data.payment_method}`}</span>
                            {account && <span className="aaf-modal-account-label">{account}</span>}
                            {creditCardImage &&
                                <img
                                src={creditCardImage}
                                alt="Credit Card Type"
                                className="credit-card-type-logo"
                            />
                            }
                        </Column>
                        {data.next_pay && (
                            <Column className='aaf-modal-payment-validity' lg={12}>
                                <span className="aaf-modal-next-pay">{Translator.get('ticket_subscription_nextPayment_label', 'Vigencia:')}</span>
                                <span className="aaf-modal-next-label">{` ${data.next_pay}`}</span>
                            </Column>
                        )}
                        {!!data.frequency && (
                            <Column className='aaf-modal-payment-validity' lg={12}>
                                <span className="aaf-modal-next-pay">{Translator.get('ticket_subscription_nextPayment_label', 'Vigencia:')}</span>
                                <span className="aaf-modal-next-label">{` ${data.frequency} ${data.duration} ${Translator.get('ticket_subscription_sufixDurationRent_label', 'después de iniciar la reproducción')}`}</span>
                            </Column>
                        )}
                    </Column>
                </Row>
            </Column>
        </Row>
    );
};

const AAFModalSuccess = (props = {}) => {
    const title = Translator.get('ticket_subscription_title', 'Ya cuentas con:');

    const buttons = [];
    
    if (props.data.from && props.data.from !== 'detailSelector' && props.data.from !== 'vcard' && props.data.from !== 'modalAddOn') {
        buttons.push({
            content: Translator.get('ticket_subscription_option_button_next', 'Aceptar'),
            props: {
                onClick: (e) => {
                    props.handlePlay && typeof props.handlePlay === 'function' && props.handlePlay(e, props.callback);
                    props.handleClose(e, props.callback);
                },
                className: 'button-container',
                variant: 'primary'
            },
        });
    } else {
        buttons.push({
            content: Translator.get('ticket_subscription_option_button_player', 'Reproducir'),
            props: {
                onClick: (e) => {
                    props.handlePlay && typeof props.handlePlay === 'function' && props.handlePlay(e, props.callback);
                    props.handleClose(e, props.callback);
                },
                className: 'button-container',
                variant: 'primary'
            },
        });
    
        buttons.push({
            content: Translator.get('', 'Cerrar'),
            props: {
                onClick: (e) => {
                    props.handleVCard && typeof props.handleVCard === 'function' && props.handleVCard(e, props.callback);
                    props.handleClose(e, props.callback);
                },
                className: 'button-container',
                variant: 'dark'
            },
        });
    }
    const p = {
        title,
        alwaysEnabled: true,
        buttons,
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: false,
        buttonsAlign: 'vertical',
        backclose: true,
    };
    return (
        <ModalWrapper {...p}>
            <BodyContent data={props.data} />
        </ModalWrapper>
    );
};

AAFModalSuccess.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalSuccess);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSuccess.jsx